import { useAsyncExecutor2 } from "async-executor-hook";
import { addDays, format } from "date-fns";
import { stringify } from "query-string";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";

import {
  WCalendar,
  WDropdown,
  WInputText,
} from "../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../common/components/TemplateContainer/TemplateContainer";
import { removeNullProps } from "../../common/utils";
import FilterIcon from "../../images/icon_filter.png";
import { AREAS, CATEGORY, STATUS } from "../../utils/complaintsConstants";
import { ClearFilterButton } from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";

export const AdminComplaintsSearch = (props) => {
  const { params$ } = props;

  const history = useHistory();

  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        caseNumber: new FormControl(),
        status: new FormControl(),
        enterDate: new FormControl(),
        area: new FormControl(),
        clientName: new FormControl(),
        category: new FormControl(),
      });

      form.patchValue(data);

      return form;
    },
    onSubmit: (form) => {
      const data = form.value;
      const enterDate = data.enterDate && format(data.enterDate, "yyyy-MM-dd");
      history.push(
        `${history.location.pathname}?${stringify(
          removeNullProps({ ...data, enterDate })
        )}`
      );
    },
  });
  useAsyncExecutor2((params) => params, {
    params$,
    onSuccess: (data) => {
      formConfig.loadSucceed(data);
    },
  });

  const category = formConfig.form?.get("category").value;

  return (
    <>
      <WForm formConfig={formConfig}>
        <div className="p-grid">
          <div className="p-col-6 p-md-3">
            <WFormControl name="caseNumber">
              <TemplateInputContainer label="Número:">
                <WInputText width="100%" placeholder="Nro del caso" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-3">
            <WFormControl name="status">
              <TemplateInputContainer label="Estado:">
                <WDropdown options={STATUS} width="100%" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-3">
            <WFormControl name="enterDate">
              <TemplateInputContainer label="Desde:">
                <WCalendar width="100%" dateFormat="dd/mm/yy" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-3">
            <WFormControl name="category">
              <TemplateInputContainer label="Categoría:">
                <WDropdown options={CATEGORY} width="100%" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
        </div>
        <div className="p-grid">
          <div className="p-col-6 p-md-3">
            <WFormControl name="clientName">
              <TemplateInputContainer label="Cliente:">
                <WInputText width="100%" placeholder="Nombre del Cliente" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-3">
            <WFormControl name="area">
              <TemplateInputContainer label="Área:">
                <WDropdown
                  options={
                    category === "COMPLAINT" ? AREAS.queja : AREAS.reclamo
                  }
                  width="100%"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>

          <div
            className="p-col-6 p-md-3"
            style={{
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <SaveButton
              label="Consultar"
              width="100%"
              height="5rem"
              backgroundColor="#002E6C"
            />
          </div>
          <div
            className="p-col-6 p-md-3"
            style={{
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <ClearFilterButton
              onClick={() => {
                const form = formConfig.form;

                form.reset({ enterDate: addDays(new Date(), -60) });
              }}
            >
              <img src={FilterIcon} alt="Limpiar filtros" />
              <div>Limpiar filtros</div>
            </ClearFilterButton>
          </div>
        </div>
      </WForm>
    </>
  );
};
